import axios from 'axios'

const getBaseUrl = () => {
  let url = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
  if (url === 'http://localhost:3000') url = 'http://localhost:3000/api';
  return url;
}

export const v2_get_request_api = async (data: any) =>
  axios.get(
    `${getBaseUrl()}/${data.queryKey[0]}?${data.queryKey[1] || ''}`
  ) as any
